import {
  LayoutDashboard,
  MapPin,
  Sheet,
  Shield,
  CheckCircle,
  Trash2,
  Home,
  Building2,
  Map,
  BookOpen,
  Tag,
  Settings,
  Cog,
  FolderTree,
  Flag,
  Heart,
  UserCheck,
} from 'lucide-react';
import { LayoutConfig } from '../../components/layout/types';

export const adminLayoutConfig: LayoutConfig = {
  brandName: "App",
  brandSubtitle: "Admin Panel",
  sidebarWidth: 288, // 72 * 4 = 288px (w-72.5 equivalent)
  headerHeight: "4rem",
  showLocationDropdown: false,
  showSearchBar: true,
  searchPlaceholder: "Search admin...",
  showViewSwitcher: false,
  menuSections: [
    {
      label: "",
      defaultOpen: true,
      items: [
        {
          icon: Home,
          label: "Dashboard",
          path: "/admin",
          color: "text-gray-600"
        },
        {
          icon: Sheet,
          label: "Users",
          path: "/admin/users",
          color: "text-green-600"
        },
        {
          icon: UserCheck,
          label: "User Approvals",
          path: "/admin/users/approvals",
          color: "text-emerald-600"
        },
        {
          icon: Trash2,
          label: "User Recycle Bin",
          path: "/admin/users/recycle-bin",
          color: "text-red-500"
        },
        {
          icon: Shield,
          label: "Permissions",
          path: "/admin/permissions",
          color: "text-purple-600"
        },
        {
          icon: Shield,
          label: "User Roles",
          path: "/admin/user-roles",
          color: "text-indigo-600"
        },
        {
          icon: CheckCircle,
          label: "Content Approvals",
          path: "/admin/approvals",
          color: "text-orange-600"
        },
        {
          icon: Flag,
          label: "Feedback",
          path: "/admin/feedback",
          color: "text-rose-500"
        },
        {
          icon: Trash2,
          label: "Recycle Bin",
          path: "/admin/recycle-bin",
          color: "text-red-600"
        }
      ]
    },
    {
      label: "Location Management",
      defaultOpen: true,
      items: [
        {
          icon: Building2,
          label: "Organizations",
          path: "/admin/organizations",
          color: "text-cyan-600"
        },
        {
          icon: Flag,
          label: "Canada",
          path: "/admin/canada",
          color: "text-red-600"
        }
      ]
    },
    {
      label: "Configuration",
      defaultOpen: true,
      items: [
        {
          icon: FolderTree,
          label: "Taxonomy",
          path: "/admin/taxonomy",
          color: "text-blue-600"
        },
        {
          icon: Cog,
          label: "Global Settings",
          path: "/admin/global-settings",
          color: "text-amber-600"
        }
      ]
    }
  ]
};



